export const easing: Record<number, string> = {
  1: "cubic-bezier(0.65,0.05,0.36,1)",
};
